import { AvailableMembersMap, MemberInterface, PulsePersona } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK - apps/server/src/API/Members/Members.Controller.ts
export class MembersAPI {
  static async loadMembers(orgId: number) {
    return APIService.Server.get<MemberInterface[]>(`/members/org/${orgId}`);
  }

  static async updateMember(orgId: number, memberId: number, member: Partial<MemberInterface>) {
    return APIService.Server.put<MemberInterface>(`/members/org/${orgId}/member/${memberId}`, member);
  }

  static async updateMyMember(orgId: number, memberId: number, member: Partial<MemberInterface>) {
    return APIService.Server.put<MemberInterface>(`/members/org/${orgId}/my-member/${memberId}`, member);
  }

  /** Admin-only (plan Decision 7): the member's Pulse persona; null removes their page. */
  static async setPersona(orgId: number, memberId: number, persona: PulsePersona | null): Promise<MemberInterface> {
    return APIService.Server.put<MemberInterface>(`/members/org/${orgId}/member/${memberId}/persona`, { persona });
  }

  static async updateMemberLastActive(orgId: number, memberId: number) {
    return APIService.Server.put<MemberInterface>(`/members/org/${orgId}/member/${memberId}/seen`);
  }

  static async addRoleToMember(orgId: number, memberId: number) {
    return APIService.Server.post<MemberInterface>(`/members/org/${orgId}/add-role/member/${memberId}`);
  }

  static async deleteMember(orgId: number, memberId: number) {
    return APIService.Server.delete<MemberInterface>(`/members/org/${orgId}/member/${memberId}`);
  }

  static async getMemberAvailability(orgId: number, memberId: number): Promise<boolean> {
    return APIService.Server.get<boolean>(`/members/org/${orgId}/member/${memberId}/availability`);
  }

  static async getAvailableMembers(orgId: number): Promise<AvailableMembersMap> {
    return APIService.Server.get<AvailableMembersMap>(`/members/org/${orgId}/available-members`);
  }

  static async setMemberAvailability(orgId: number, memberId: number, available: boolean) {
    return APIService.Server.put<boolean>(`/members/org/${orgId}/member/${memberId}/availability/${available}`);
  }

  static async generateMemberTwilioToken(orgId: number, memberId: number, locationId?: number) {
    return APIService.Server.put<string>(`/members/org/${orgId}/member/${memberId}/twilio-token`, { locationId });
  }

  static async clearMemberTwilioToken(orgId: number, memberId: number) {
    return APIService.Server.delete<void>(`/members/org/${orgId}/member/${memberId}/twilio-token`);
  }

  static async getMemberByAgentId(orgId: number, memberId: number) {
    return APIService.Server.get<MemberInterface>(`/members/org/${orgId}/agent/${memberId}`);
  }
}
